// Mock data for local development mode only
// This file contains all dummy data used when REACT_APP_LOCAL_DEVELOPMENT=true

import { ENDPOINT } from "./endpoint";

interface FetchOptions extends RequestInit {
  headers?: Record<string, string>;
  body?: any;
  signal?: AbortSignal;
}

const generateCreatorEmails = (count: number) => {
  const emails: string[] = [];
  for (let i = 1; i <= count; i += 1) {
    emails.push(`test${i}@test.com`);
  }
  return emails;
};

export const mockRecords = [
  {
    source_system: "OCE-P",
    ts_id: "REC-001",
    review_types: "PV",
    last_modified_date: "2025-02-01",
    created_dt: "2025-01-25",
    ts_region: "EMEA",
    country: "Poland",
    product: "Product A",
    risk_types: "HC",
    hc_severity: "high",
    ae_pc_ss_severity: "",
    hc_reason: "Data discrepancy",
    ae_pc_ss_reason: "",
    status: "Passed",
    affiliates: "Affiliate-1",
    sample_creator_email: "user@company.com",
    sample_id: "20260219_1204_7506_PCO,PTQ,PV",
    sample: true,
    pass_count: [2, 1],
    fail_count: [0, 0],
    evaluation_risk_type: ["AE", "HC"],
    sample_review_type: "PV",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-002",
    review_types: "HCO",
    last_modified_date: "2025-01-30",
    created_dt: "2025-01-20",
    ts_region: "EMEA",
    country: "Germany",
    product: "Product B",
    risk_types: "AE, PC, SS",
    hc_severity: "",
    ae_pc_ss_severity: "low",
    hc_reason: "",
    ae_pc_ss_reason: "Spelling error",
    status: "Failed",
    affiliates: "Affiliate-2",
    sample_creator_email: "reviewer@company.com",
    sample_id: "20250219_1204_7506_PCO,PTQ,PV",
    sample: true,
    pass_count: [1, 0],
    fail_count: [1, 2],
    evaluation_risk_type: ["HC", "SS"],
    sample_review_type: "HCO",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-003",
    review_types: "PV",
    last_modified_date: "2025-01-28",
    created_dt: "2025-01-15",
    ts_region: "APAC",
    country: "Japan",
    product: "Product C",
    risk_types: "HC",
    hc_severity: "low",
    ae_pc_ss_severity: "",
    hc_reason: "Minor issue detected",
    ae_pc_ss_reason: "",
    status: "Passed",
    affiliates: "Affiliate-3",
    sample_creator_email: "auditor@company.com",
    sample_id: "20240115_0930_5123_PCO,PTQ",
    sample: true,
    pass_count: [3, 2],
    fail_count: [0, 0],
    evaluation_risk_type: ["AE", "PC"],
    sample_review_type: "PV",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-004",
    review_types: "PCO",
    last_modified_date: "2025-01-26",
    created_dt: "2025-01-10",
    ts_region: "Americas",
    country: "USA",
    product: "Product A",
    risk_types: "AE, PC, SS",
    hc_severity: "",
    ae_pc_ss_severity: "high",
    hc_reason: "",
    ae_pc_ss_reason: "Regulatory violation",
    status: "Pending",
    affiliates: "Affiliate-1",
    sample_creator_email: "compliance@company.com",
    sample_id: "20260219_1204_7506_PCO,PTQ,PV",
    sample: false,
    pass_count: [1, 1],
    fail_count: [2, 1],
    evaluation_risk_type: ["HC", "SS"],
    sample_review_type: "PCO",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-005",
    review_types: "PV",
    last_modified_date: "2025-01-24",
    created_dt: "2025-01-08",
    ts_region: "EMEA",
    country: "United Kingdom",
    product: "Product B",
    risk_types: "HC, AE, PC, SS",
    hc_severity: "high",
    ae_pc_ss_severity: "medium",
    hc_reason: "Incomplete data",
    ae_pc_ss_reason: "Missing attachment",
    status: "Passed",
    affiliates: "Affiliate-2",
    sample_creator_email: "validator@company.com",
    sample_id: "20250219_1204_7506_PCO,PTQ,PV",
    sample: false,
    pass_count: [2, 2],
    fail_count: [0, 1],
    evaluation_risk_type: ["AE", "HC"],
    sample_review_type: "PV",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-006",
    review_types: "PV",
    last_modified_date: "2025-02-02",
    created_dt: "2025-01-28",
    ts_region: "APAC",
    country: "China",
    product: "Product C",
    risk_types: "HC, AE, PC, SS",
    hc_severity: "high",
    ae_pc_ss_severity: "high",
    hc_reason: "Critical safety concern identified",
    ae_pc_ss_reason: "Serious adverse event reported",
    status: "Failed",
    affiliates: "Affiliate-3",
    sample_creator_email: "safety@company.com",
    sample_id: "20240115_0930_5123_PCO,PTQ",
    sample: false,
    pass_count: [0, 0],
    fail_count: [3, 3],
    evaluation_risk_type: ["AE", "HC", "PC", "SS"],
    sample_review_type: "PV",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-NR-001",
    review_types: "SKIP",
    last_modified_date: "2026-02-20",
    created_dt: "2026-02-15",
    ts_region: "EMEA",
    country: "France",
    product: "Product C",
    risk_types: "NR",
    hc_severity: "",
    ae_pc_ss_severity: "",
    hc_reason: "",
    ae_pc_ss_reason: "Unsupported language (language_code)",
    status: "Available for Review",
    affiliates: "Affiliate-3",
    sample_creator_email: "",
    sample_id: "",
    sample: false,
    pass_count: [],
    fail_count: [],
    evaluation_risk_type: [],
    sample_review_type: "",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-NR-002",
    review_types: "SKIP",
    last_modified_date: "2026-02-21",
    created_dt: "2026-02-16",
    ts_region: "US",
    country: "USA",
    product: "Product D",
    risk_types: "NR",
    hc_severity: "",
    ae_pc_ss_severity: "",
    hc_reason: "",
    ae_pc_ss_reason: "",
    status: "Available for Review",
    affiliates: "Affiliate-4",
    sample_creator_email: "",
    sample_id: "",
    sample: false,
    pass_count: [],
    fail_count: [],
    evaluation_risk_type: [],
    sample_review_type: "",
  },
];

export const mockDashboardData = {
  total_records: 250,
  passed_records: 180,
  failed_records: 50,
  pending_records: 20,
  by_risk: {
    HIGH: 45,
    MEDIUM: 85,
    LOW: 120,
  },
  by_region: {
    EMEA: 100,
    APAC: 80,
    Americas: 70,
  },
  by_status: {
    Passed: 180,
    Failed: 50,
    Pending: 20,
  },
  monthly_trend: [
    { month: "Jan", passed: 45, failed: 10, pending: 5 },
    { month: "Feb", passed: 135, failed: 40, pending: 15 },
  ],
};

export const mockAuditLogs = [
  {
    id: "LOG-001",
    user: "john.doe@company.com",
    action: "REVIEWED",
    record_id: "REC-001",
    timestamp: "2025-02-01T10:30:00Z",
    status: "Passed",
    details: "Record reviewed and approved",
  },
  {
    id: "LOG-002",
    user: "jane.smith@company.com",
    action: "CREATED",
    record_id: "REC-002",
    timestamp: "2025-01-30T14:15:00Z",
    status: "Pending",
    details: "New record created in system",
  },
  {
    id: "LOG-003",
    user: "admin@company.com",
    action: "EXPORTED",
    record_id: null,
    timestamp: "2025-01-28T09:45:00Z",
    status: "Success",
    details: "Records exported to CSV",
  },
];

export const mockRefData = {
  ref_country: [
    { ts_region: "EMEA", country_name: "Poland" },
    { ts_region: "EMEA", country_name: "Germany" },
    { ts_region: "EMEA", country_name: "United Kingdom" },
    { ts_region: "APAC", country_name: "Japan" },
    { ts_region: "APAC", country_name: "China" },
    { ts_region: "Americas", country_name: "USA" },
    { ts_region: "Americas", country_name: "Canada" },
  ],
  ref_risk_type: [
    { risk_type_code: "HIGH", risk_type: "High Risk" },
    { risk_type_code: "MEDIUM", risk_type: "Medium Risk" },
    { risk_type_code: "LOW", risk_type: "Low Risk" },
  ],
  ref_evaluation_type: [
    { evaluation_type: "PV" },
    { evaluation_type: "HCO" },
    { evaluation_type: "PCO" },
  ],
  ref_status: [
    { record_status: "Passed" },
    { record_status: "Failed" },
    { record_status: "Pending" },
  ],
  ref_product: [
    { product: "Product A" },
    { product: "Product B" },
    { product: "Product C" },
  ],
  sample_data: [
    { sample_id: "20260219_1204_7506_PCO,PTQ,PV", team_created_for: "PCO, PTQ, PV" },
    { sample_id: "20250219_1204_7506_PCO,PTQ,PV", team_created_for: "PCO, PTQ, PV" },
    { sample_id: "20240115_0930_5123_PCO,PTQ", team_created_for: "PCO, PTQ" },
    { sample_id: "20260101_0800_1234_PCO", team_created_for: "PCO" },
  ],
};

export const mockNarrativeData = [
  {
    source_system: "OCE-P",
    ts_id: "REC-001",
    review_types: "PV",
    last_modified_date: "2025-02-01",
    created_dt: "2025-01-25",
    ts_region: "EMEA",
    country: "Poland",
    product: "Product A",
    risk_types: "HC",
    hc_severity: "high",
    ae_pc_ss_severity: "",
    hc_reason: "Data discrepancy",
    ae_pc_ss_reason: "",
    status: "Passed",
    affiliates: "Affiliate-1",
    sample_id: "20260219_1204_7506_PCO,PTQ,PV",
    sample: false,
    sample_created_on: "2025-01-20",
    sample_review_type: "PV",
    therapeutic_area: "Oncology",
    version_id: 1,
    latest: "Yes",
    translation_score: 4.5,
    id: "TEXT-001",
    creator_emails: [
      "adam.cooper@company.com",
      "margaret.richardson@company.com",
      "eric.cox@company.com",
      "dorothy.howard@company.com",
      "frank.ward@company.com",
      "betty.torres@company.com",
      "george.peterson@company.com",
      "helen.gray@company.com",
      "henry.ramirez@company.com",
      "diane.james@company.com",
      "jack.watson@company.com",
      "gloria.brooks@company.com",
      "john.kelly@company.com",
      "alice.sanders@company.com",
      "joseph.price@company.com",
      "ann.bennett@company.com",
      "larry.long@company.com",
      "sara.barnes@company.com",
      "mark.ross@company.com",
      "ruth.henderson@company.com",
      "neil.coleman@company.com",
      "joyce.jenkins@company.com",
      "paul.perry@company.com",
      "kathryn.powell@company.com",
      "peter.long@company.com",
      "rose.patterson@company.com",
      "randy.hughes@company.com",
      "diane.flores@company.com",
      "ryan.washington@company.com",
      "julia.butler@company.com",
      "scott.simmons@company.com",
      "michael.adkins@company.com",
      "patricia.alexander@company.com",
      "david.allen@company.com",
      "barbara.anders@company.com",
      "james.anderson@company.com",
      "dorothy.andrews@company.com",
      "robert.anthony@company.com",
      "margaret.arthur@company.com",
      "richard.ashley@company.com",
      "betty.austin@company.com",
      "charles.bailey@company.com",
      "helen.baker@company.com",
      "thomas.baldwin@company.com",
      "ruth.ball@company.com",
      "daniel.banks@company.com",
      "janet.barber@company.com",
      "matthew.barnard@company.com",
      "joyce.barnes@company.com",
      "anthony.barrett@company.com",
      "barbara.barton@company.com",
      "mark.bascom@company.com",
      "diane.bass@company.com",
      "donald.bates@company.com",
      "carol.bauer@company.com",
      "steven.beach@company.com",
      "sandra.beans@company.com",
      "paul.bear@company.com",
      "shirley.beard@company.com",
      "andrew.beaty@company.com",
      "catherine.beck@company.com",
      "joshua.becker@company.com",
      "gloria.beckham@company.com",
      "kenneth.bedford@company.com",
      "alice.beebe@company.com",
      "kevin.beech@company.com",
      "carol.beecher@company.com",
      "brian.beeler@company.com",
      "rose.beers@company.com",
      "gary.begley@company.com",
      "marie.beidler@company.com",
      "edward.beland@company.com",
      "betty.belanger@company.com",
      "timothy.belisle@company.com",
      "clara.bell@company.com",
      "ronald.bella@company.com",
      "helen.bellamy@company.com",
      "jason.bellamy@company.com",
      "dorothy.bellen@company.com",
      "jeffrey.bellew@company.com",
      "margaret.belli@company.com",
      "ryan.bellis@company.com",
      "anne.bellman@company.com",
      "jacob.bellmer@company.com",
      "helen.bello@company.com",
      "gary.bellomy@company.com",
      "betty.bellows@company.com",
      "nicholas.bellucio@company.com",
      "patricia.belly@company.com",
      "jonathan.belmont@company.com",
      "diane.belote@company.com",
      "samuel.belote@company.com",
      "kathryn.below@company.com",
      "frank.belshaw@company.com",
      "ruth.belski@company.com",
      "gregory.belson@company.com",
      "rose.belsomini@company.com",
      "alexander.belstra@company.com",
      "gloria.belton@company.com",
      "raymond.belue@company.com",
      "jean.belushi@company.com",
      "patrick.belvalkar@company.com",
      "margaret.belvedere@company.com",
      "jack.belvins@company.com",
      "helen.belz@company.com",
      "dennis.belzak@company.com",
      "dorothy.belzer@company.com",
      "jerry.bembe@company.com",
      "alice.bemis@company.com",
      "tyler.bemrose@company.com",
      "sarah.ben@company.com",
      "aaron.bena@company.com",
      "marie.benac@company.com",
      "jose.benage@company.com",
      "jean.benages@company.com",
      "adam.benamen@company.com",
      "rose.benami@company.com",
      "henry.benamon@company.com",
      "ruth.benard@company.com",
      "douglas.benario@company.com",
      "betty.benarts@company.com",
      "peter.benasse@company.com",
      "helen.benatan@company.com",
      "michael.benatti@company.com",
      "anne.benaud@company.com",
      "david.benaul@company.com",
      "clara.benavidez@company.com",
      "james.benaya@company.com",
      "margaret.benayoun@company.com",
      "robert.benboe@company.com",
      "dorothy.bench@company.com",
      "richard.benchley@company.com",
      "betty.bencik@company.com",
      "charles.bencini@company.com",
      "helen.benckley@company.com",
      "thomas.bencz@company.com",
      "ruth.bend@company.com",
      "daniel.bendall@company.com",
      "margaret.bendeau@company.com",
      "matthew.bendeck@company.com",
      "jean.bender@company.com",
      "anthony.bendery@company.com",
      "gloria.bendetti@company.com",
      "mark.bendini@company.com",
      "rose.bending@company.com",
      "donald.bendowski@company.com",
      "diane.bendrose@company.com",
      "steven.bendure@company.com",
      "sarah.benduson@company.com",
      "paul.bendy@company.com",
      "betty.bendyshyn@company.com",
      "andrew.bendzunas@company.com",
      "carol.bene@company.com",
      "joshua.benea@company.com",
      "catherine.beneck@company.com",
      "kenneth.benedek@company.com",
      "dorothy.benedetti@company.com",
      "kevin.benedic@company.com",
      "alice.benedict@company.com",
      "brian.benedicto@company.com",
      "margaret.benedictos@company.com",
      "gary.benedix@company.com",
      "helen.benediz@company.com",
      "edward.benediczi@company.com",
      "betty.benedictus@company.com",
      "timothy.benedicto@company.com",
      "clara.benedit@company.com",
      "ronald.benedita@company.com",
      "jean.benedite@company.com",
      "jason.benedith@company.com",
      "rose.benedicto@company.com",
      "jeffrey.benedon@company.com",
      "margaret.benedox@company.com",
      "ryan.beneducce@company.com",
      "dorothy.benedum@company.com",
      "jacob.benedure@company.com",
      "betty.benefield@company.com",
      "gary.benegas@company.com",
      "ruth.benegar@company.com",
      "nicholas.benege@company.com",
      "alice.beneger@company.com",
      "jonathan.benegeria@company.com",
      "margaret.benegros@company.com",
      "samuel.beneguitz@company.com",
      "gloria.benegus@company.com",
      "frank.benegyal@company.com",
      "helen.benehaam@company.com",
      "gregory.beneham@company.com",
      "marie.benehamer@company.com",
      "alexander.benehana@company.com",
      "dorothy.benehan@company.com",
      "raymond.benehra@company.com",
      "betty.benei@company.com",
      "patrick.beneish@company.com",
      "rose.beneja@company.com",
      "jack.benejan@company.com",
      "alice.benejam@company.com",
      "dennis.benejamm@company.com",
      "margaret.benejan@company.com",
      "jerry.benejan@company.com",
      "jean.benejan@company.com",
      "tyler.benejan@company.com",
      "sarah.benejan@company.com",
      "aaron.beneken@company.com",
      "marie.beneked@company.com",
      "jose.beneken@company.com",
      "dorothy.beneken@company.com",
      "adam.benekett@company.com",
      "betty.benelam@company.com",
      "henry.beneles@company.com",
      "helen.benelesh@company.com",
      "douglas.benelet@company.com",
      "ruth.benelex@company.com",
      "peter.benelich@company.com",
      "margaret.benelis@company.com",
      "michael.benella@company.com",
      "clara.benellah@company.com",
      "david.benellal@company.com",
      "alice.benelles@company.com",
      "james.benelli@company.com",
      "jean.benello@company.com",
      "robert.benellos@company.com",
      "rose.benellum@company.com",
      "richard.benelly@company.com",
      "gloria.benelm@company.com",
      "charles.benelmans@company.com",
      "betty.benelon@company.com",
      "thomas.benelors@company.com",
      "anne.beneloup@company.com",
      "daniel.benelos@company.com",
      "dorothy.benelous@company.com",
      "matthew.benelprecht@company.com",
      "margaret.benels@company.com",
      "anthony.benelsken@company.com",
      "diane.benelt@company.com",
      "mark.benelu@company.com",
      "catherine.benely@company.com",
      "donald.benelvaki@company.com",
      "sarah.benelvakis@company.com",
      "steven.benelvakos@company.com",
      "betty.benenati@company.com",
      "paul.benendit@company.com",
      "helen.benendite@company.com",
      "andrew.benedicta@company.com",
      "rose.benefell@company.com",
      "joshua.benefelds@company.com",
      "gloria.benefelds@company.com",
      "kenneth.benefert@company.com",
      "alice.benefiel@company.com",
      "kevin.benefils@company.com",
      "ruth.benegord@company.com",
      "brian.benegal@company.com",
      "margaret.benegara@company.com",
      "gary.benegara@company.com",
      "jean.benegar@company.com",
      "edward.benegars@company.com",
      "dorothy.benegasm@company.com",
      "timothy.benegasso@company.com",
      "betty.benegats@company.com",
      "ronald.benegauer@company.com",
      "alice.benegato@company.com",
      "jason.beneg@company.com",
      "margaret.benegaue@company.com",
      "jeffrey.benegaues@company.com",
      "helen.benegault@company.com",
      "ryan.benegaumon@company.com",
      "rose.benegaumont@company.com",
      "jacob.benegaumont@company.com",
      "gloria.benegaumont@company.com",
      "gary.benegaumonts@company.com",
      "betty.benegave@company.com",
      "nicholas.benegawes@company.com",
      "anne.benegayer@company.com",
      "jonathan.benegayers@company.com",
      "margaret.benegayers@company.com",
      "samuel.benegayler@company.com",
      "diana.benegaylers@company.com",
      "frank.benegaymond@company.com",
      "dorothy.benegaymons@company.com",
    ],
    field_name: "Patient Narrative - This is a very long field name to test how the column handles overflow in the PDF table header rendering",
    field_value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus feugiat, lorem at facilisis tincidunt, purus metus interdum lorem, sed porta elit risus et nunc. Integer non justo sed turpis fermentum aliquet. Suspendisse potenti. Donec euismod, urna in placerat facilisis, enim sapien bibendum est, sed dignissim lorem odio id purus. Curabitur vitae nulla vel turpis elementum suscipit. Praesent at orci nec leo dictum gravida. Aliquam erat volutpat. Phasellus euismod, nisl at convallis varius, nulla lorem tincidunt massa, a tempor erat justo non urna. Sed nec felis ac elit vehicula sodales. Morbi ut lacus non ipsum malesuada malesuada. Nam euismod, sapien at vulputate dictum, augue erat fermentum nunc, nec luctus libero justo vitae purus. Aenean non libero sed elit sagittis gravida. Duis vitae lectus sed neque malesuada cursus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nullam id metus at lorem vulputate posuere.",
    source_language: "English",
    translated_name: "Narracja Pacjenta",
    translated_text: "Pacjent doświadczył zdarzenia niepożądanego",
    target_language: "Polish",
    translation_message: "Translation completed successfully",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-002",
    review_types: "HCO",
    last_modified_date: "2025-01-30",
    created_dt: "2025-01-20",
    ts_region: "EMEA",
    country: "Germany",
    product: "Product B",
    risk_types: "AE, PC, SS",
    hc_severity: "",
    ae_pc_ss_severity: "low",
    hc_reason: "",
    ae_pc_ss_reason: "Spelling error",
    status: "Failed",
    affiliates: "Affiliate-2",
    sample_id: "20250219_1204_7506_PCO,PTQ,PV",
    sample: false,
    sample_created_on: "2025-01-20",
    sample_review_type: "HCO",
    therapeutic_area: "Cardiology",
    version_id: 1,
    latest: "Yes",
    translation_score: 3.8,
    id: "TEXT-003",
    creator_emails: [
      "reviewer@company.com",
      "john.smith@company.com",
      "sarah.johnson@company.com",
      "michael.brown@company.com",
      "emily.davis@company.com",
    ],
    field_name: "Patient Narrative",
    field_value: "אנהרטו יש תופעות לוואי קשות, הוא לא יחליף לדעתה את הטיפול בפסגו ובמוקדם יתנו אותו רק לאוכלוסיית היי ריסק",
    source_language: "Hebrew",
    translated_name: "Narracja Pacjenta",
    translated_text: "Pacjent doświadczył błędów ortograficznych",
    target_language: "Polish",
    translation_message: "Translation completed with minor errors",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-003",
    review_types: "PV",
    last_modified_date: "2025-01-28",
    created_dt: "2025-01-15",
    ts_region: "APAC",
    country: "Japan",
    product: "Product C",
    risk_types: "HC",
    hc_severity: "low",
    ae_pc_ss_severity: "",
    hc_reason: "Minor issue detected",
    ae_pc_ss_reason: "",
    status: "Passed",
    affiliates: "Affiliate-3",
    sample_id: "20240115_0930_5123_PCO,PTQ",
    sample: false,
    sample_created_on: "2025-01-20",
    sample_review_type: "PV",
    therapeutic_area: "Neurology",
    version_id: 1,
    latest: "Yes",
    translation_score: 4.1,
    id: "TEXT-004",
    creator_emails: [
      "auditor@company.com",
      "paul.anderson@company.com",
      "linda.martinez@company.com",
      "robert.garcia@company.com",
      "jennifer.rodriguez@company.com",
      "william.wilson@company.com",
      "elizabeth.lopez@company.com",
      "charles.gonzalez@company.com",
      "mary.perez@company.com",
      "joseph.sanchez@company.com",
      "susan.ramirez@company.com",
      "thomas.torres@company.com",
      "margaret.rivera@company.com",
      "christopher.flores@company.com",
      "patricia.gomez@company.com",
      "daniel.diaz@company.com",
      "nancy.cruz@company.com",
      "matthew.reyes@company.com",
      "karen.morales@company.com",
      "anthony.jimenez@company.com",
    ],
    field_name: "Patient Narrative",
    field_value: "Minor spelling and grammar issues found",
    source_language: "English",
    translated_name: "Narracja Pacjenta",
    translated_text: "Znalezione drobne błędy ortograficzne i gramatyczne",
    target_language: "Polish",
    translation_message: "Translation completed successfully",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-004",
    review_types: "PCO",
    last_modified_date: "2025-01-26",
    created_dt: "2025-01-10",
    ts_region: "Americas",
    country: "USA",
    product: "Product A",
    risk_types: "AE, PC, SS",
    hc_severity: "",
    ae_pc_ss_severity: "high",
    hc_reason: "",
    ae_pc_ss_reason: "Regulatory violation",
    status: "Pending",
    affiliates: "Affiliate-1",
    sample_id: "20260219_1204_7506_PCO,PTQ,PV",
    sample: false,
    sample_created_on: "2025-01-15",
    sample_review_type: "PCO",
    therapeutic_area: "Gastroenterology",
    version_id: 1,
    latest: "Yes",
    translation_score: 3.5,
    id: "TEXT-005",
    creator_emails: generateCreatorEmails(2000),
    field_name: "Patient Narrative",
    field_value: "Regulatory compliance issue detected in submission",
    source_language: "English",
    translated_name: "Narracja Pacjenta",
    translated_text: "Wykryto problem zgodności przepisów w zgłoszeniu",
    target_language: "Polish",
    translation_message: "Translation completed with warnings",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-005",
    review_types: "PV",
    last_modified_date: "2025-01-24",
    created_dt: "2025-01-08",
    ts_region: "EMEA",
    country: "United Kingdom",
    product: "Product B",
    risk_types: "HC, AE, PC, SS",
    hc_severity: "high",
    ae_pc_ss_severity: "medium",
    hc_reason: "Incomplete data",
    ae_pc_ss_reason: "Missing attachment",
    status: "Passed",
    affiliates: "Affiliate-2",
    sample_id: "20250219_1204_7506_PCO,PTQ,PV",
    sample: false,
    sample_created_on: "2025-01-12",
    sample_review_type: "PV",
    therapeutic_area: "Rheumatology",
    version_id: 1,
    latest: "Yes",
    translation_score: 4.3,
    id: "TEXT-006",
    creator_email: "validator@company.com",
    field_name: "Patient Narrative",
    field_value: "Records contain incomplete patient data requiring clarification",
    source_language: "English",
    translated_name: "Narracja Pacjenta",
    translated_text: "Rekordy zawierają niekompletne dane pacjenta wymagające wyjaśnienia",
    target_language: "Polish",
    translation_message: "Translation completed successfully",
  },
  {
    source_system: "OCE-P",
    ts_id: "REC-006",
    review_types: "PV",
    last_modified_date: "2025-02-02",
    created_dt: "2025-01-28",
    ts_region: "APAC",
    country: "China",
    product: "Product C",
    risk_types: "HC, AE, PC, SS",
    hc_severity: "high",
    ae_pc_ss_severity: "high",
    hc_reason: "Critical safety concern identified",
    ae_pc_ss_reason: "Serious adverse event reported",
    status: "Pending",
    affiliates: "Affiliate-3",
    sample_id: "20240115_0930_5123_PCO,PTQ",
    sample: false,
    sample_created_on: "2025-01-30",
    sample_review_type: "PV",
    therapeutic_area: "Immunology",
    version_id: 1,
    latest: "Yes",
    translation_score: 4.0,
    id: "TEXT-007",
    creator_emails: [
      "safety@company.com",
      "compliance.officer@company.com",
    ],
    field_name: "Patient Narrative",
    field_value: "Critical safety alert regarding adverse event with serious consequences",
    source_language: "English",
    translated_name: "Narracja Pacjenta",
    translated_text: "Alert bezpieczeństwa dotyczący zdarzenia niepożądanego o poważnych konsekwencjach",
    target_language: "Polish",
    translation_message: "Translation completed with priority flagging",
  },
];

export const mockEvaluationData = [
  {
    ts_id: "REC-001",
    evaluation_id: "EVAL-001",
    status: "Approved",
    risk_type: ["AE", "HC"],
    reviewer_email_id: "reviewer@company.com",
    evaluated_on: "2025-02-01T14:30:00Z",
    corrective_action: "No action required, record passed all checks",
  },
  {
    ts_id: "REC-002",
    evaluation_id: "EVAL-003",
    status: "Pending",
    risk_type: ["AE", "SS"],
    reviewer_email_id: "reviewer@company.com",
    evaluated_on: "2025-01-30T11:00:00Z",
    corrective_action: "Awaiting review",
  },
  {
    ts_id: "REC-003",
    evaluation_id: "EVAL-004",
    status: "Approved",
    risk_type: ["HC"],
    reviewer_email_id: "auditor@company.com",
    evaluated_on: "2025-01-29T09:30:00Z",
    corrective_action: "Minor issues resolved, record approved",
  },
  {
    ts_id: "REC-004",
    evaluation_id: "EVAL-005",
    status: "Pending",
    risk_type: ["AE", "SS", "PC"],
    reviewer_email_id: "compliance@company.com",
    evaluated_on: "2025-01-27T16:00:00Z",
    corrective_action: "Regulatory review in progress",
  },
  {
    ts_id: "REC-005",
    evaluation_id: "EVAL-006",
    status: "Approved",
    risk_type: ["HC", "AE", "PC", "SS"],
    reviewer_email_id: "validator@company.com",
    evaluated_on: "2025-01-25T13:15:00Z",
    corrective_action: "All data verified and complete, record approved",
  },
  {
    ts_id: "REC-006",
    evaluation_id: "EVAL-007",
    status: "Pending",
    risk_type: ["HC", "AE", "PC", "SS"],
    reviewer_email_id: "safety@company.com",
    evaluated_on: "2025-02-02T10:00:00Z",
    corrective_action: "Safety escalation required, awaiting management review",
  },
];

// Mock data function for local development
export const getMockData = (endpoint: string, options?: FetchOptions): any => {
  switch (endpoint) {
    case ENDPOINT.GET_NOTIFICATION_DATA:
      return [];

    case ENDPOINT.GET_REF_DATA:
      return mockRefData;

    case ENDPOINT.GET_RECORD_LIST:
      return { data: mockRecords, filtered_record_count: mockRecords.length };

    case ENDPOINT.GET_RECORD_LIST_BY_NEEDS_REVIEW:
      return { data: mockRecords, filtered_record_count: mockRecords.length };

    case ENDPOINT.GET_DASHBOARD_DATA:
      return mockDashboardData;

    case ENDPOINT.GET_AUDIT_LOGS:
      return { data: mockAuditLogs };

    case ENDPOINT.RECORD_INFO: {
      // Extract recordId from request body
      let recordId = "REC-001";
      if (options?.body) {
        try {
          const body = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
          recordId = body.recordId || "REC-001";
        } catch {
          console.log("Could not parse body for recordId");
        }
      }

      // Filter narrative and evaluation data by recordId
      return {
        "narrative-data": mockNarrativeData.filter((item: any) => item.ts_id === recordId),
        "evaluation-data": mockEvaluationData.filter((item: any) => item.ts_id === recordId),
      };
    }

    case ENDPOINT.ADD_REVIEW:
    case ENDPOINT.SAMPLE_GENERATION:
    case ENDPOINT.RATING:
      return { success: true, message: "Operation completed successfully" };

    case ENDPOINT.EXPORT_RECORD:
    case ENDPOINT.EXPORT_AUDIT_LOGS:
      return { success: true };

    case ENDPOINT.EXPORT_POLL_DATA:
      return { status: "completed", data: mockNarrativeData };

    case ENDPOINT.GET_NO_RISK_DATA: {
      const nrRecords = mockRecords.filter((r: any) => r.risk_types === 'NR');
      return { data: nrRecords, filtered_record_count: nrRecords.length };
    }

    case ENDPOINT.GET_REVIEWED_LIST:
      return { data: mockRecords, filtered_record_count: mockRecords.length };

    default:
      return { message: "Mock data not available for this endpoint" };
  }
};
